import { ArrowRight, CheckCircle2 } from 'lucide-react'

interface StageCompleteNavProps {
  nextLabel: string
  onNext: () => void
}

// Shown under a stage once it's finished, regardless of which experience mode
// (Classic/Guided) produced that result — this sits in the shared
// wrapper in index.tsx rather than inside any one mode's view.
export function StageCompleteNav({ nextLabel, onNext }: StageCompleteNavProps) {
  return (
    <div
      className="mt-4 flex items-center justify-between gap-3 rounded-[14px] px-5 py-3.5"
      style={{ background: 'rgba(52,211,153,.08)', border: '1px solid rgba(52,211,153,.3)' }}
    >
      <div className="flex items-center gap-2 min-w-0">
        <CheckCircle2 size={16} className="text-emerald-700 shrink-0" />
        <span className="text-[12px] font-medium text-[#1e293b] truncate">This stage is complete.</span>
      </div>
      <button
        onClick={onNext}
        className="flex items-center gap-1.5 px-4 py-2 rounded-[9px] text-[12px] font-semibold text-white transition-all shrink-0"
        style={{ background: '#6366f1', boxShadow: '0 3px 10px rgba(99,102,241,.35)' }}
      >
        Continue to {nextLabel} <ArrowRight size={13} />
      </button>
    </div>
  )
}
